export default angular
    .module('syValiadteInputFile', [])
    .directive('requiredFile', function () {
        return {
            require: 'ngModel',
            link: function (scope, el, attrs, ngModel) {
                //Change event is fired when file is selected
                el.bind('change', function () {
                    scope.$apply(function () {
                        ngModel.$setViewValue(el.val())
                        ngModel.$render()
                    })
                })
            }
        }
    })
    .directive('equalWith', function () {
        return {
            require: 'ngModel',
            scope: { equalWith: '&' },
            link: function (scope, elem, attrs, ngModel) {
                ngModel.$validators.equalWith = function (modelValue) {
                    return modelValue === scope.equalWith()
                }
                scope.$watch(scope.equalWith, function () {
                    ngModel.$validate()
                })
            }
        }
    })
    .directive('notEqualWith', function () {
        return {
            require: 'ngModel',
            scope: { notEqualWith: '&' },
            link: function (scope, elem, attrs, ngModel) {
                ngModel.$validators.notEqualWith = function (modelValue) {
                    return modelValue != scope.notEqualWith()
                }
                scope.$watch(scope.notEqualWith, function () {
                    ngModel.$validate()
                })
            }
        }
    })
    .directive('reseize', [
        '$window',
        '$timeout',
        function ($window, $timeout) {
            return function (scope) {
                var w = angular.element($window)
                scope.getWindowDimensions = function () {
                    return {
                        h: w.innerHeight,
                        w: w.innerWidth
                    }
                }
                scope.$watch(
                    scope.getWindowDimensions,
                    function (w) {
                        scope.style = function () {
                            return {
                                height: w.h - 10 + 'px',
                                width: w.w - 10 + 'px'
                            }
                        }
                    },
                    true
                )
                w.bind('reseize', function () {
                    scope.$apply()
                })
                $timeout(function () {
                    w.triggerHandler('reseize')
                }, 100)
            }
        }
    ])
